/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const EDGE: CommunityData = {
  code: "edge",
  inviteCode: "edgeberlin",
  name: "EDGE",
  thumbnail: "",
  favicon: "",
  waitlist: false,
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/edg-030`,
  socials: {},
  styles: {
    comingSoon: {
      bgColor: "#000000",
      hero: {
        desktop: "https://media.werz.at/community-assets/EDGE/web-hero-v2.mp4?type=video",
        mobile: "https://media.werz.at/community-assets/EDGE/web-hero-v2.mp4?type=video",
        style: "bg-[#222222]",
      },
      logo: {
        desktop: "https://media.werz.at/community-assets/EDGE/cs-logo.png",
        mobile: "https://media.werz.at/community-assets/EDGE/cs-logo.png",
        style: "w-[160px] h-[29px] sm:w-[210px] sm:h-[38px]",
      },
      werzLogoColor: "#FFFFFF",
      title:
        "font-['MonumentExtendedRegular'] text-[28px] leading-[120%] text-[#ffffff] uppercase text-center sm:text-left",
      text: "font-['OpenSansRegular'] text-[16px] leading-[120%] text-[#ffffff]",
      button:
        "font-['MonumentExtendedRegular'] text-[14px] leading-[120%] uppercase p-4 rounded-lg bg-[#ffffff] text-[#000000] cursor-pointer w-fit",
      input: {
        base: "font-['OpenSansRegular'] text-[14px] leading-[120%] w-[256px] rounded-lg px-4 h-[48px] bg-[#000000] text-[#ffffff]",
        border: "#444444",
        borderFocus: "#ffffff",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['OpenSansRegular'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['OpenSansRegular'] text-[14px] leading-[120%] text-[#8D8D8D]",
      skipButton:
        "font-['OpenSansRegular'] text-[14px] leading-[120%] text-[#8D8D8D] cursor-pointer",
      modal: {
        container: "bg-[#0F0F0F] px-[40px] py-[48px]",
        title:
          "font-['MonumentExtendedRegular'] text-[24px] leading-[120%] text-[#ffffff] text-center",
        text: "font-['OpenSansRegular'] text-[14px] leading-[120%] text-[#8D8D8D] text-center",
        width: "w-[358px]",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-white bg-black font-['OpenSansRegular'] text-[16px] leading-[120%] text-center",
        otpBorder: "#444444",
        otpBorderFocus: "#ffffff",
      },
    },
    global: {
      counterColor: "#000000",
      logo: {
        src: "https://media.werz.at/community/icon/cmgqjn42900009k2qpxc2vyfy.jpg?uploadTime=1760522470450&type=image&v=1762238616236",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: "https://media.werz.at/community-assets/EDGE/web-alternative-logo.png",
        styles: "w-[160px] h-[29px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#ffffff",
      asideBg: "#8283fb",
      asideStyles: "border-r-[1px] border-[#ffffff00]",
      contentBg: "#ffffff",
      contentBoxShadow: "",
      bgDesktop: "https://media.werz.at/community-assets/EDGE/web-background.jpg",
      bgMobile: "https://media.werz.at/community-assets/EDGE/web-background-mobile.jpg",
      nonMemberBg: "https://media.werz.at/community-assets/EDGE/web-background-non-member.png",
      mainFont: "font-['OpenSansRegular']",
      primaryButton:
        "bg-[#000000] border border-[#000000] rounded-lg px-[18px] py-[18px] !text-[#ffffff] font-['MonumentExtendedRegular'] !text-[14px] uppercase text-left",
      scrollArrow: {
        background: "#000000",
        color: "#ffffff",
      },
    },
    navigation: {
      iconsColor: "#000000",
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      separator: "#000000",
      item: "text-[#000000] font-['MonumentExtendedRegular'] text-[13px] uppercase text-left gap-x-[10px] text-opacity-50 text-center border-b border-[#000000] !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "bg-[#ffffff] rounded-[24px] !pb-8 overflow-hidden",
      titles:
        "text-[#000000] font-['MonumentExtendedRegular'] text-[20px] uppercase text-left leading-[120%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#000000] font-['OpenSansRegular'] text-[15px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0",
        sectionTitle:
          "text-[#000000] font-['MonumentExtendedRegular'] text-[20px] uppercase text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff00] border-0",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#000000] font-['MonumentExtendedRegular'] text-[20px] uppercase text-left leading-[120%]",
          subtitle:
            "text-[#000000] font-['OpenSansRegular'] text-[15px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0",
        sectionTitle:
          "text-[#000000] font-['MonumentExtendedRegular'] text-[20px] uppercase text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00] border-0",
          mediaContainer:
            "w-full sm:!w-[228px] sm:flex-shrink-0 sm:!h-[128px] relative overflow-hidden",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-transparent p-4",
          title:
            "text-[#000000] font-['MonumentExtendedRegular'] text-[20px] uppercase sm:text-[16px] text-left text-[16px] leading-[120%] mb-2",
          subtitle: "text-[#000000] font-['OpenSansRegular'] text-[12px] text-left leading-[120%]",
          location: "text-[#000000] font-['OpenSansRegular'] text-[12px] text-left leading-[120%]",
          date: "text-[#000000] font-['OpenSansRegular'] text-[12px] text-left leading-[120%] mb-1",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#000000] font-['MonumentExtendedRegular'] text-[16px] uppercase text-left leading-[120%]",
        text: "text-[#000000] font-['OpenSansRegular'] text-[16px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#000000] font-['MonumentExtendedRegular'] text-[16px] uppercase text-left leading-[120%] !mb-4 sm:!mb-4",
      },
    },
    linktree: {
      bgDesktop: "https://media.werz.at/community-assets/EDGE/web-background-non-member.png",
      bgMobile: "https://media.werz.at/community-assets/EDGE/web-background-non-member.png",
      bgColor: "#ffffff",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#ffffff]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border border-[#000000]",
        name: "text-[#ffffff] font-['MonumentExtendedRegular'] text-[20px] uppercase leading-[24px] text-center text-center mt-4 mb-1",
        location:
          "font-['MonumentExtendedRegular'] uppercase leading-[16.8px] text-[16px] text-center text-center mb-2",
        description:
          "text-[#000000] font-['OpenSansRegular'] text-[16px] leading-[120%] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#000000",
        button:
          "bg-[#ffffff00] border border-[#000000] rounded-lg px-4 py-3 text-[#000000] font-['MonumentExtendedRegular'] text-[13px] uppercase text-left w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] border border-[#000000] rounded-[24px] text-[#000000] font-['OpenSansRegular'] text-[16px] leading-[120%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#ffffff] border border-[#000000] rounded-[24px]",
          title:
            "font-['MonumentExtendedRegular'] uppercase leading-[16.8px] text-[16px] text-left text-center mb-1",
          text: "text-[#000000] font-['OpenSansRegular'] text-[16px] leading-[120%] text-center text-center",
          button:
            "bg-[#ffffff00] border border-[#000000] rounded-lg px-4 py-3 text-[#000000] font-['MonumentExtendedRegular'] text-[13px] uppercase text-left w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#ffffff] font-['MonumentExtendedRegular'] uppercase leading-[16.8px] text-[16px] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border border-[#000000] rounded-[24px]",
          duration:
            "text-[#000000] font-['OpenSansRegular'] text-[12px] leading-[14.4px] text-left",
          name: "text-[#000000] font-['MonumentExtendedRegular'] uppercase leading-[16.8px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#000000",
          media: "overflow-hidden m-2 border border-[#000000] rounded-[24px]",
        },
        event: {
          container:
            "overflow-hidden sm:w-[500px] w-[95vw] bg-[#ffffff] border border-[#000000] rounded-[24px]",
          name: "text-[#000000] font-['MonumentExtendedRegular'] uppercase leading-[16.8px] text-[16px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#000000] border border-[#000000] rounded-[8px] text-[#ffffff] font-['OpenSansSemiBold'] text-[16px] leading-[19.2px] text-center",
          duration:
            "text-[#000000] font-['OpenSansRegular'] text-[12px] leading-[14.4px] text-left",
          location:
            "text-[#000000] font-['OpenSansRegular'] text-[12px] leading-[14.4px] text-left",
          button:
            "bg-[#ffffff00] border border-[#000000] rounded-lg px-4 py-3 text-[#000000] font-['MonumentExtendedRegular'] text-[13px] uppercase text-left w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#000000]",
            name: "text-[#000000] font-['OpenSansSemiBold'] leading-[19.2px] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price:
              "text-[#000000] font-['OpenSansSemiBold'] leading-[19.2px] text-[14px] text-left",
            link: "text-[#000000] font-['OpenSansRegular'] text-[15px] leading-[18px] text-left",
            status: "text-[#000000] font-['OpenSansSemiBold'] leading-[120%] text-[14px] text-left",
            button:
              "bg-[#ffffff00] border border-[#000000] rounded-lg px-4 py-3 text-[#000000] font-['MonumentExtendedRegular'] text-[13px] uppercase text-left w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#000000] font-['OpenSansRegular'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] border border-[#000000] rounded-[24px] text-[#000000] font-['OpenSansRegular'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['MonumentExtendedRegular'] uppercase leading-[16.8px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border border-[#000000] rounded-[24px]",
          name: "text-[#000000] font-['MonumentExtendedRegular'] uppercase leading-[16.8px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#000000",
          created: "text-[#000000] font-['OpenSansRegular'] text-[12px] leading-[14.4px] text-left",
          media: "overflow-hidden m-2 border border-[#000000] rounded-[24px]",
        },
        seeAllNews:
          "text-[#000000] font-['OpenSansRegular'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] border border-[#000000] rounded-[24px] text-[#000000] font-['OpenSansRegular'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['MonumentExtendedRegular'] uppercase leading-[16.8px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border border-[#000000] rounded-[24px]",
          coverUrl: "overflow-hidden m-2 border border-[#000000] rounded-[24px]",
          duration:
            "text-[#000000] font-['OpenSansRegular'] text-[12px] leading-[14.4px] text-left",
          liveType:
            "text-[#000000] font-['OpenSansRegular'] text-[12px] leading-[14.4px] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#000000] rounded-full",
          playIconColor: "#FFF",
          playIconBackgroundColor: "#000000",
          playIconBorderColor: "#FFF",
          start: "text-[#000000] font-['OpenSansRegular'] text-[12px] leading-[14.4px] text-left",
          title:
            "text-[#000000] font-['MonumentExtendedRegular'] uppercase leading-[16.8px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#000000] font-['OpenSansRegular'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] border border-[#000000] rounded-[24px] text-[#000000] font-['OpenSansRegular'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['MonumentExtendedRegular'] uppercase leading-[16.8px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border border-[#000000] rounded-[24px]",
          name: "text-[#000000] font-['MonumentExtendedRegular'] uppercase leading-[16.8px] text-[16px] text-left",
          triangleIconColor: "#000000",
          circleIcon:
            "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#000000] rounded-[24px]",
        },
      },
      footer: {
        WERZlogoColor: "#000000",
        text: "text-[#000000] font-['OpenSansRegular'] text-[12px] leading-[14.4px] text-left",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#ffffff] rounded-[24px] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title:
          "text-[#000000] font-['MonumentExtendedRegular'] text-[20px] uppercase text-left leading-[120%]",
        subtitle:
          "text-[#000000] font-['OpenSansRegular'] text-[15px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#000000] border border-[#000000] rounded-lg px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['MonumentExtendedRegular'] text-[14px] uppercase text-left",
        questions: "text-[15px] text-left leading-[120%] text-[#000000]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#000000] font-['MonumentExtendedRegular'] text-[16px] uppercase text-left leading-[120%]",
        text: "text-[#000000] font-['OpenSansRegular'] text-[15px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#000000] font-['MonumentExtendedRegular'] text-[16px] uppercase text-left leading-[120%]",
        text: "text-[#000000] font-['OpenSansRegular'] text-[15px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#000000] font-['MonumentExtendedRegular'] text-[16px] uppercase text-left leading-[120%]",
        text: "text-[#000000] font-['OpenSansRegular'] text-[15px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#000000] font-['MonumentExtendedRegular'] text-[20px] uppercase text-left leading-[120%] px-4 sm:px-8 py-4 sm:py-8 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#ffffff] rounded-[24px] !pb-8 border-0",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "!bg-[#ffffff00] border border-[#000000] rounded-lg px-4 py-3 text-[#000000] font-['MonumentExtendedRegular'] text-[13px] uppercase text-left !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto border-b border-[#000000] mb-4 pb-4",
          media: "!hidden",
          name: "text-[#000000] font-['OpenSansSemiBold'] text-[16px] text-left leading-[120%]",
          description:
            "text-[#000000] font-['OpenSansRegular'] text-[15px] text-left leading-[120%] !mt-1",
          price:
            "text-[#000000] font-['OpenSansSemiBold'] text-[16px] text-left leading-[120%] !mt-1",
          quantity:
            "text-[#000000] font-['MonumentExtendedRegular'] text-[13px] uppercase text-left mt-1",
          status: "text-[#000000] font-['OpenSansSemiBold'] text-[16px] text-left leading-[120%]",
          counterContainer:
            "bg-[#ffffff00] border border-[#000000] rounded-lg px-4 py-3 gap-x-4 !w-fit !h-10",
          button:
            "!bg-[#ffffff00] border border-[#000000] rounded-lg px-4 py-3 text-[#000000] font-['MonumentExtendedRegular'] text-[13px] uppercase text-left !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default EDGE
